// extracted by mini-css-extract-plugin
export var quantityInput = "_nm-0";